import axios from "axios";
import { DataGrid } from "devextreme-react";
import { Column, Scrolling, StateStoring } from "devextreme-react/data-grid";
import { useEffect, useRef, useState } from "react";

export default function ProjectList(props) {
  const { currentEmployee } = props;

  const [dataSource, setDataSource] = useState(null);

  useEffect(async () => {
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_BECCO_API_URL}/api/prjAsgmt?employeeNo=${currentEmployee.employeeNo}`
      );

      setDataSource(result.data);
    } catch (error) {
      console.error(error);
    }
  }, [currentEmployee]);

  const cellRender = (data) => {
    return (
      <div
        // className="dx-colorbox-color-result-preview"
        style={{
          backgroundColor: data.data.color,
          left: "13px",
          width: "17px",
          height: "17px",
          border: "1px solid",
          borderColor: "#e0e0e0",
        }}
      >
        {/* {data.data.color} */}
      </div>
    );
  };

  return (
    <DataGrid
      key={("contrNo", "role")}
      dataSource={dataSource}
      hoverStateEnabled={true}
      showBorders={true}
      showColumnHeaders={true}
      showColumnLines={true}
      width={"100%"}
      allowColumnResizing={true}
      // style={{
      //   maxHeight: "calc(100vh-180px)",
      // }}
      height={400}
    >
      <Scrolling mode={"virtual"} showScrollbar="always" />

      <StateStoring
        enabled={true}
        type="localStorage"
        storageKey={"Organization.ProjectList"}
      />

      <Column
        dataField={"assignedDate"}
        caption="Assigned Date"
        dataType={"date"}
        format="yyyy-MM-dd"
        width={130}
        alignment="center"
      />
      <Column
        dataField={"role"}
        caption="Role"
        width={130}
        alignment="center"
      />
      <Column
        dataField={"color"}
        caption=""
        cellRender={cellRender}
        width={40}
      />
      <Column
        dataField={"contrNo"}
        caption="Contract No."
        width={150}
        alignment="center"
      />
      <Column dataField={"name"} caption="Project Name" />
    </DataGrid>
  );
}
